import { humaniseEnumKey } from "@/lib/enumLabel";

/**
 * Display labels for compensation-MODEL keys. Categorical labels only — never
 * a percentage, cap or dollar figure (firm product rule).
 *
 * Two key spellings are in the database for the same concepts: the profile
 * editor writes `capping_model` / `tiered_splits`, while other write paths use
 * the shorter `cap_based` / `tiered`. Both are mapped — an org that selected a
 * capping model must not render a blank pill because of which form wrote it.
 */
export const MODEL_LABELS: Record<string, string> = {
  flat_split: "Fixed Commission",
  capping_model: "Capping Model",
  cap_based: "Capping Model",
  "100_commission": "100% Commission",
  tiered_splits: "Tiered Commission",
  tiered: "Tiered Commission",
  profit_share: "Profit Share",
  revenue_share: "Revenue Share",
  stock_equity: "Stock / Equity Options",
  signing_bonus: "Signing Bonus",
  transaction_bonuses: "Transaction Bonuses",
  team_override: "Team Override",
  salary: "Salary",
  draw_against_commission: "Draw Against Commission",
  company_lead_commission: "Company Lead Commission",
};

/** Never drop an unmapped key — humanise it so the value still shows. */
export const modelLabel = (key: string): string => MODEL_LABELS[key] || humaniseEnumKey(key);
